export const isLocalhost = () => window && window.location.hostname === 'localhost';
